"use client";
import { Button, Card, Typography } from "antd";
import "./style.css"; // CSS riêng
import Link from "antd/lib/typography/Link";
import logo from "~/assets/logo/logo-no-bg.png";
import apetechsLogo from "~/assets/logo/logo-no-bg.png";
import { configEnv } from "~/@config";
const { Title, Text } = Typography;

export const LoginView = () => {
  const { ROOT } = configEnv().CONNECTORS;
  const { baseUrl } = ROOT;
  const handleApetechsLogin = () => {
    const redirectUri = encodeURIComponent(
      `${window.location.origin}/ape-callback`
    );
    window.location.href = `${baseUrl}api/client/auth/ape?redirectUri=${redirectUri}`;
  };

  return (
    <div className="login-container">
      <Card className="login-card">
        <div className="login-header">
          <Link href="/">
            <img src={logo} alt="Logo" width={64} height={64} />
          </Link>
          <Title level={3}>Đăng nhập hệ thống</Title>
          <Text type="secondary">
            Sử dụng tài khoản Apetechs để truy cập nền tảng
          </Text>
        </div>

        <div className="login-content">
          <Button
            className="apetechs-login-button"
            onClick={handleApetechsLogin}
            block
            type="primary"
            size="large"
          >
            <img src={apetechsLogo} alt="Apetechs" className="apetechs-logo" />
            Đăng nhập với Apetechs
          </Button>

          <div className="login-description">
            <Text type="secondary">
              Sử dụng tài khoản Apetechs của bạn để truy cập vào hệ thống đấu
              thầu
            </Text>
          </div>
        </div>

        <div className="register-link">
          Chưa có tài khoản? <Link href="/register">Đăng ký ngay</Link>
        </div>
      </Card>
    </div>
  );
};
